import { useGameStore } from '../../store/gameStore';

interface FlipAnimationOptions {
  isWordFound?: boolean;
}

export const menuAnimationDelay = 170;

export const applyFlipAnimation = (tile: HTMLElement | null, options?: FlipAnimationOptions) => {
  if (!tile) return;
  setTimeout(() => {
    tile?.classList.add('tile-flip');
    if (options?.isWordFound) {
      tile?.classList.remove('tile-bonus');
      tile?.classList.remove('tile-found');
      tile?.classList.remove('tile-found-blue');
      tile?.classList.remove('tile-found-purple');
      tile?.classList.remove('tile-found-pink');
      tile?.classList.remove('tile-found-red');
      tile?.classList.remove('tile-found-yellow');
      tile?.classList.remove('tile-found-galaxy');
      tile?.classList.remove('tile-found-fire');
      tile?.classList.remove('tile-found-ice');
      // tile?.classList.remove('tile-found-halloween');
      // tile?.classList.remove('tile-found-christmas');
      tile?.classList.add('tile-empty');
    }
  }, 0);
  setTimeout(() => {
    tile?.classList.remove('tile-flip');
  }, 250);
};

export const applyFoundAnimation = (tile: HTMLElement | null, idx: number) => {
  if (!tile) return;
  const foundColor = useGameStore.getState().foundColor;
  setTimeout(() => {
    if (foundColor === 'green') tile?.classList.add('tile-found');
    else if (foundColor === 'blue') tile?.classList.add('tile-found-blue');
    else if (foundColor === 'purple') tile?.classList.add('tile-found-purple');
    else if (foundColor === 'pink') tile?.classList.add('tile-found-pink');
    else if (foundColor === 'red') tile?.classList.add('tile-found-red');
    else if (foundColor === 'rainbow') {
      if (idx === 0) tile?.classList.add('tile-found-red');
      else if (idx === 1) tile?.classList.add('tile-found-yellow');
      else if (idx === 2) tile?.classList.add('tile-found');
      else if (idx === 3) tile?.classList.add('tile-found-blue');
      else if (idx === 4) tile?.classList.add('tile-found-purple');
    } else if (foundColor === 'galaxy') tile?.classList.add('tile-found-galaxy');
    else if (foundColor === 'fire') tile?.classList.add('tile-found-fire');
    else if (foundColor === 'ice') tile?.classList.add('tile-found-ice');
    // else if (foundColor === 'halloween') tile?.classList.add('tile-found-halloween');
    // else if (foundColor === 'christmas') tile?.classList.add('tile-found-christmas');
  }, 0);
};

export const applySwapCounterAnimation = () => {
  const swapTile = document.getElementById('swap-tile');
  setTimeout(() => {
    swapTile?.classList.add('tile-flip');
  }, 0);
  setTimeout(() => {
    swapTile?.classList.remove('tile-flip');
  }, 250);
};

export const applyEndGameAnimation = (boardSize: number) => {
  const delay = 260;
  setTimeout(() => {
    Array.from({ length: boardSize }).forEach((_, i) => {
      Array.from({ length: boardSize }).forEach((_, j) => {
        setTimeout(() => {
          const tile = document.getElementById(`${i}-${j}`);
          tile?.classList.add('tile-flip');
          setTimeout(() => {
            tile?.classList.remove('tile-flip');
          }, 250);
        }, i * 120);
      });
    });
  }, delay);
};

export const applyTitleAnimation = () => {
  const titleTile1 = document.getElementById('title-1');
  const titleTile2 = document.getElementById('title-2');

  setTimeout(() => {
    titleTile1?.classList.add('tile-flip');
  }, 300);
  setTimeout(() => {
    titleTile1?.classList.remove('tile-flip');
    titleTile2?.classList.add('tile-flip');
  }, 650);
  setTimeout(() => {
    titleTile2?.classList.remove('tile-flip');
  }, 900);
};
